import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18 6 6 18M6 6l12 12" })
});
export default SvgCross;
